import(/* webpackMode: "eager" */ "/app/node_modules/@cosmos/web-react/dist/esm/components.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/storyblok/[localeString]/support-hub/loading.module.css");
